import { WppActionButton, WppIconRefresh } from '@wppopen/components-library-react'
import clsx from 'clsx'

interface Props {
  refreshHandler: () => void
  className?: string
  isLoading?: boolean
}

function ManualRefreshButton({ refreshHandler, className, isLoading }: Props) {
  return (
    <WppActionButton
      onClick={refreshHandler}
      className={clsx(className)}
      disabled={isLoading}
      data-testid="manual-refresh-button"
    >
      Refresh
      <WppIconRefresh slot="icon-start" />
    </WppActionButton>
  )
}

export default ManualRefreshButton
